<template>
    <div class="devservice">
        <Navbar class="adjust"/>  
        <router-view></router-view>
    </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue';
export default {
    name: 'devservice',
    components: {
        Navbar
    }
}
</script>

<style scoped>
.logo-size{
    height: 40px;
    width: 135px;
}
.adjust{
    margin-bottom: 100px;
}
</style>